export default function xAxis() {
  return {
      autorange: true,
      showgrid: false,
      zeroline: false,
      showticklabels: false,
      ticks: ''
  }
}